import * as React from 'react';
import {
  Container, Link, Card, Box, Typography, Collapse, CardActionArea
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation, Trans } from "react-i18next";
import PageWrapperBox from 'components/PageWrapperBox';

const LBL = {fontWeight: "bold", color: "text.primary_bold", display: "inline-block", width: 170};
const NUM = {width: 30, textAlign: "left", fontWeight: "bold", color: "primary.main"};

export default function FaqPage() {

    const { t } = useTranslation();

    const mailLink = <Link href={"mailto:" + t("common.email")} underline="none" />;
    const rules = "https://www.tennisenpadelvlaanderen.be/padel/klassementen-berekening";

    const rich = {
        b: <b/>,
        br: <br/>,
        link: mailLink,
        about: <Link href="about" />,
        hl: <Typography sx={{fontWeight: "bold", color: "text.primary_bold", display: "inline"}} />,
        p: <Typography sx={{fontWeight: "bold", color: "primary.main", display: "inline"}} />,
    };

    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="primary" component="div">
                {t("faq.title")}
            </Typography>


            <Typography variant="body" fontWeight="light" component="div" >
                {t("faq.subtitle")}
            </Typography>
            </PageWrapperBox>

            <FAQ title={t("faq.q1.title")} sx={{mt: 2}}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q1.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q2.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q2.intro" components={rich}/><br/>

                    <Typography sx={{...LBL, mt: 1}}>{t("calculation.roundPoule")}</Typography>
                    <b>{t("common.wp")}</b> <Typography display="inline-block" sx={NUM} component="div">1</Typography>
                    <b>{t("common.vp")}</b> <Typography display="inline-block" sx={NUM} component="div">1</Typography><br/>
                    <Typography sx={LBL}>{t("calculation.roundTable")}</Typography>
                    <b>{t("common.wp")}</b> <Typography display="inline-block" sx={NUM} component="div">1.5</Typography>
                    <b>{t("common.vp")}</b> <Typography display="inline-block" sx={NUM} component="div">0.5</Typography><br/>

                    {t("calculation.categoryIntro")}<br/>
                    <Typography sx={{...LBL, mt: 1}}>{t("calculation.catMenWomen")}</Typography>{t("calculation.percentOfPoints", {percent: 100})}<br/>
                    <Typography sx={LBL}>{t("calculation.catInterclub")}</Typography>{t("calculation.percentOfPoints", {percent: 80})}<br/>
                    <Typography sx={LBL}>{t("calculation.catMixedMan")}</Typography>{t("calculation.percentOfPoints", {percent: 40})}<br/>
                    <Typography sx={{...LBL, mb: 1}}>{t("calculation.catMixedWoman")}</Typography>{t("calculation.percentOfPoints", {percent: 100})}<br/>
                    <Typography sx={{...LBL, mb: 1}}>{t("calculation.catLegends")}</Typography>{t("calculation.percentOfPoints", {percent: 40})}<br/>
                    <Trans i18nKey="calculation.womenInMenSeries" components={{
                        link: <Link underline="none" sx={{fontWeight: "bold"}} href={rules} color="primary" />
                    }}/><br/>

                    <Trans i18nKey="faq.q2.outro" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q3.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q3.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q4.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q4.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q5.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q5.body" components={{
                        ...rich,
                        link: <Link underline="none" sx={{fontWeight: "bold"}} href="https://tennisvlaanderen.m9.mailplus.nl/archief/mailing-4463875.html" color="primary" />
                    }}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q6.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q6.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q7.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q7.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q8.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q8.body" components={rich}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q9.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q9.body" components={rich}/>
                </Typography>
            </FAQ>

    </PageWrapper>
}

const FAQ = ({title, children, sx}) => {
    const [open, setOpen] = React.useState(false);



    return <>

    <Box sx={{backgroundColor: "primary.main", borderRadius: 2, mb: 1, ...sx}}>
        <CardActionArea sx={{flexDirection: "row", display: "flex", py: 1, px: 2, justifyContent: "flex-start"}} onClick={()=>{setOpen(!open)}}>
            <ChevronRightIcon style={{ transform: open ? "rotate(90deg)" : "rotate(0)", transition: "all 0.1s linear", color: "white" }}/>

            <Typography sx={{px: 1, color: "white"}} fontWeight="bold">{title}</Typography>
        </CardActionArea>
    </Box>

    <Collapse in={open}>
        {children}
    </Collapse>

</>}
